<div [formGroup]="formGroup">
  <div class="row mb-input-margin-bottom">
    <div class="col-12 field-wrapper text-sm-left"
         mbFloatingLabel data-cy="mb-billing-vat-id">
      <label for="vatId" class="mandatory-input-asterisk mb-input-field-cursor mb-custom-label">{{ 'address.vatId' | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             id="vatId"
             type="text"
             name="vatId"
             formControlName="vatId"
             data-cy="mb-billing-address-vat-id-input"
             required/>
      <mb-form-errors [control]="formGroup?.get(constants.VAT_ID_CODE)"
                      [prefix]="'formValidationErrors'">
      </mb-form-errors>
    </div>
  </div>
</div>
